import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { calculateHomeVisitPrice } from '@/utils';

export default function Review({ formData }) {
	const appointmentLocation = [
		formData.addressLine1,
		formData.addressLine2,
		formData.city,
		formData.postcode,
		'United Kingdom',
	]
		.filter((part) => part && part.trim() !== '')
		.join(', ');

	return (
		<Stack spacing={2}>
			<List disablePadding>
				<ListItem sx={{ py: 1, px: 0 }}>
					<ListItemText primary="Test" secondary={`${formData.selectedService.service_name}`} />
					<Typography variant="body2">
						£{(formData.selectedService.service_price / 100).toFixed(2)}
					</Typography>
				</ListItem>
				<ListItem sx={{ py: 1, px: 0 }}>
					<ListItemText primary="Additional cost" />
					<Typography variant="body2">£{formData.selectedNursePrice}</Typography>
				</ListItem>
				<ListItem sx={{ py: 1, px: 0 }}>
					<ListItemText primary="Total" />
					<Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
						{calculateHomeVisitPrice(
							formData.selectedService.service_price,
							formData.selectedNursePrice
						)}
					</Typography>
				</ListItem>
			</List>
			<Divider />
			<Stack direction="column" divider={<Divider flexItem />} spacing={2} sx={{ my: 2 }}>
				<div>
					<Typography variant="subtitle2" gutterBottom>
						Appointment location
					</Typography>
					<Typography gutterBottom>
						{formData.firstName} {formData.lastName}
					</Typography>
					<Typography gutterBottom sx={{ color: 'text.secondary' }}>
						{appointmentLocation}
					</Typography>
				</div>
			</Stack>
		</Stack>
	);
}
